// library imports
import { Button, Form, InputNumber, Flex, Skeleton } from "antd";
import { useEffect, useState, useContext } from "react";
// hook imports
import useFetch from "../../../hooks/useFetch";
// context imports
import { IndexContext } from "../../../context/IndexContext";
// config imports
import { FORM_REQUIRED } from "../../../configs/configs";

export default function GoalForm({
  mode,
  setIsModalOpen,
  refreshTable,
  initialValues,
  siteSelected,
  yearSelected,
  isEditCarbonEmissionGoal,
  isEditRevenueTarget,
}) {
  // fetch wrapper
  const [fetchWrapper] = useFetch();

  // loading states
  const [loading, setLoading] = useState(false); // loading state for form
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false); // loading state for submit button

  const [goalForm] = Form.useForm();

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to add goal */
  function addGoal(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "goal_management/addGoal",
      body: {
        site_id: siteSelected,
        year_selected: yearSelected.format("YYYY"),
        carbon_emission_goal: user_inputs.CarbonEmissionGoal,
        revenue_target: user_inputs.RevenueTarget,
      },
      onSuccess: (fetch_output) => {
        messageApi.open({
          type: "success",
          content: fetch_output.message,
        });
        setIsModalOpen(false);
        goalForm.resetFields();
        setLoadingSubmitButton(false);
        refreshTable();
      },
    });
  }

  /* API to edit goal */
  function editGoal(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "goal_management/editGoal",
      body: {
        goal_id: initialValues[0].ID,
        goal_value: isEditCarbonEmissionGoal
          ? user_inputs.CarbonEmissionGoal
          : user_inputs.RevenueTarget,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.data === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsModalOpen(false);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.message,
          });
        }
        goalForm.resetFields();
        setLoadingSubmitButton(false);
        refreshTable();
      },
    });
  }

  useEffect(() => {
    if (mode === "edit") {
      setLoading(true);
      if (initialValues.length) {
        goalForm.setFieldsValue(initialValues[0]);
        setLoading(false);
      }
    }
  }, [mode, initialValues]);

  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <Form
          form={goalForm}
          name="goal-form"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          onFinish={(values) => {
            if (mode === "add") {
              addGoal(values);
            } else {
              editGoal(values);
            }
          }}
          autoComplete="off"
        >
          {(mode === "add" ||
            (mode === "edit" && isEditCarbonEmissionGoal)) && (
            <Form.Item
              label="Carbon Emission Goal"
              name="CarbonEmissionGoal"
              rules={[
                {
                  required: FORM_REQUIRED,
                  message: "Carbon emission goal cannot be empty.",
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} addonAfter="tCO₂e" />
            </Form.Item>
          )}

          {(mode === "add" || (mode === "edit" && isEditRevenueTarget)) && (
            <Form.Item
              label="Revenue Target"
              name="RevenueTarget"
              rules={[
                {
                  required: FORM_REQUIRED,
                  message: "Revenue target cannot be empty.",
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} addonBefore="RM" />
            </Form.Item>
          )}

          <Flex justify="center">
            <Button
              className="mr-2"
              onClick={() => {
                setIsModalOpen(false);
                goalForm.resetFields();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loadingSubmitButton}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      )}
    </>
  );
}
